import Notify from 'quasar/src/plugins/Notify.js';;
Notify.setDefaults({
  position: 'center',
  timeout: 1200
});